import { useSite } from "@/context/SiteContext";

export default function AnnouncementBar() {
  const { settings } = useSite();
  if (!settings.announcement_enabled || !settings.announcement_bar) return null;
  return (
    <div data-testid="announcement-bar" className="bg-gradient-to-r from-[#D4AF37] to-[#F0D77B] text-[#0A0A0A] text-center text-[11px] sm:text-xs font-semibold uppercase tracking-[0.15em] py-2 px-4">
      {settings.announcement_bar}
    </div>
  );
}
